import { render, staticRenderFns } from "./settings-filters-pane.vue?vue&type=template&id=2ae13b4e&scoped=true"
import script from "./settings-filters-pane.vue?vue&type=script&lang=js"
export * from "./settings-filters-pane.vue?vue&type=script&lang=js"
import style0 from "./settings-filters-pane.vue?vue&type=style&index=0&id=2ae13b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae13b4e",
  null
  
)

export default component.exports